module.exports = __webpack_public_path__ + "static/media/dk2037.a394e462.png";